import { render, staticRenderFns } from "./StorageSpaceMediaAdd.vue?vue&type=template&id=8c503d36&"
import script from "./StorageSpaceMediaAdd.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports